import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekContainer = styled(Container)(({ theme }) => ({}));

export { PeekContainer, PeekContainer as default };
